import React from 'react';
import { XMarkIcon, FolderIcon } from '@heroicons/react/24/solid';
import SpinnerLoad from 'views/notepad/moduleComponents/spinner_load';

const EmbeddedNotepadClusterPicker = ({
  isOpen,
  onClose,
  clusters,
  isLoading,
  isSubmitting = false,
  submittingClusterId = null,
  onSelect,
  title = 'Link cluster',
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    if (!isSubmitting) onClose();
  };

  const handleCloseClick = () => {
    if (!isSubmitting) onClose();
  };

  return (
    <>
      <div
        className="fixed inset-0 z-[90] bg-black/40"
        onClick={handleBackdropClick}
        aria-hidden="true"
      />
      <div
        className="fixed inset-x-4 top-1/2 z-[100] mx-auto max-h-[80vh] w-full max-w-lg -translate-y-1/2 overflow-hidden rounded-2xl bg-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="embedded-notepad-cluster-picker-title"
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
          <h3 id="embedded-notepad-cluster-picker-title" className="text-base font-semibold text-gray-800">
            {title}
          </h3>
          <button
            type="button"
            onClick={handleCloseClick}
            disabled={isSubmitting}
            className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="max-h-[calc(80vh-56px)] overflow-y-auto p-3">
          {isLoading && clusters.length === 0 ? (
            <div className="flex items-center justify-center py-12">
              <SpinnerLoad />
            </div>
          ) : clusters.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10 text-center">
              <FolderIcon className="mb-3 h-12 w-12 text-gray-300" />
              <p className="text-sm text-gray-500">No clusters available. Create clusters in Notepad first.</p>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              {clusters.map((cluster) => {
                const isRowSubmitting =
                  isSubmitting && String(submittingClusterId) === String(cluster.id);

                return (
                  <button
                    key={cluster.id}
                    type="button"
                    onClick={() => onSelect(cluster)}
                    disabled={isSubmitting}
                    className="flex w-full items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition-shadow hover:shadow-md disabled:cursor-wait disabled:opacity-70"
                  >
                    <span
                      className="h-4 w-4 shrink-0 rounded-full"
                      style={{ backgroundColor: cluster.color || '#9CA3AF' }}
                    />
                    <span className="min-w-0 flex-1 truncate text-sm font-medium text-gray-800">
                      {cluster.name}
                    </span>
                    {isRowSubmitting && <SpinnerLoad size="small" />}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EmbeddedNotepadClusterPicker;
